export const IShowToastUseCaseType = Symbol('IShowToastUseCase');
